import { IconPaths, ModalSize } from '../../../../../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button, useModal } from '../../../../../../components'
import { EspecialidadeModal } from '../modal/EspecialidadeModal'

export const EspecialidadeListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()

  const openModal = () =>
    showModal({
      title: 'Criar Especialidade',
      content: <EspecialidadeModal />,
      size: ModalSize.Medium,
    })

  return (
    <Button onClick={openModal} icon={IconPaths.Add} className='btn-primary'>
      {t('common.add')}
    </Button>
  )
}
